exports.components = {
  "component---src-templates-agenda-tsx": () => import("./../../../src/templates/agenda.tsx" /* webpackChunkName: "component---src-templates-agenda-tsx" */),
  "component---src-templates-homepage-tsx": () => import("./../../../src/templates/homepage.tsx" /* webpackChunkName: "component---src-templates-homepage-tsx" */),
  "component---src-templates-news-tsx": () => import("./../../../src/templates/news.tsx" /* webpackChunkName: "component---src-templates-news-tsx" */),
  "component---src-templates-venue-tsx": () => import("./../../../src/templates/venue.tsx" /* webpackChunkName: "component---src-templates-venue-tsx" */)
}

